var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_1722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.59239 2.12305C0.713259 2.12305 0 2.83631 0 3.71544C0 4.21638 0.235541 4.68746 0.636957 4.98935L7.8558 10.4035C8.23399 10.6855 8.75152 10.6855 9.12971 10.4035L16.3486 4.98935C16.75 4.68746 16.9855 4.21638 16.9855 3.71544C16.9855 2.83631 16.2722 2.12305 15.3931 2.12305H1.59239ZM0 5.83863V12.739C0 13.9101 0.952117 14.8622 2.12319 14.8622H14.8623C16.0334 14.8622 16.9855 13.9101 16.9855 12.739V5.83863L9.76667 11.2528C9.01028 11.82 7.97523 11.82 7.21884 11.2528L0 5.83863Z",
    fill: "#727272"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_1722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.9855,
    height: 16.9855,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormEmailIcon);
export default __webpack_public_path__ + "static/media/formEmailIcon.548ddb56121b639ed86d30c17c1fa1b2.svg";
export { ForwardRef as ReactComponent };